<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="myQrCode" class="full-width-input" style="width: 100%; height: 500px"
      label-width="80px" :size="defaultFormItemSize" label-position="top" @submit.native.prevent >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="userInfo.showName">
<!--            <el-upload-->
<!--              class="upload-image-item" name="uploadFile" :headers="getUploadHeaders"-->
<!--              :action="headImageUploadUrl"-->
<!--              :show-file-list="false" accept=".jpg,.png,.jpeg"-->
<!--              :on-success="onHeadImageUploadSuccess"-->
<!--              :on-error="onUploadError" :on-exceed="onUploadLimit"-->
<!--            >-->
              <img class="upload-image-show" style="width: 300px;height: 300px" :src="dataInfo.qrCode">
<!--            </el-upload>-->
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SystemController } from '@/api';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';

export default {
  name: 'formModifyHeadImage',
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      userInfo: {},
      dataInfo: {}
    }
  },
  methods: {

    getHeadImageUrl () {
      console.log(this.userInfo)
      SystemController.getQrCode(this, {
        isSpecial: this.userInfo.isSpecial
      }).then(res => {
        this.dataInfo = res.data
      }).catch(e => {});
    }
  },
  computed: {

    ...mapGetters(['getUserInfo'])
  },
  mounted () {
    this.userInfo = this.$store.state.userInfo
    this.getHeadImageUrl()
  }
}
</script>

<style>
</style>
